/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapid_Eager_Otter_HumInputs */

const fr_rapid_eager_otter_hum = /** @type {(inputs: Rapid_Eager_Otter_HumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarif`)
};

/**

* @param {Rapid_Eager_Otter_HumInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const rapid_eager_otter_hum = /** @type {((inputs?: Rapid_Eager_Otter_HumInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapid_Eager_Otter_HumInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_rapid_eager_otter_hum(inputs)
});